class Logger {
    trace = (message: any, ...params: any[]) => {
        if (message != null)
            console.trace(`[${this.GenerateLogDateTime()}] - ${message}`, ...params);
    }

    log = (message: any, ...params: any[]) => {
        if (message != null)
            console.log(`[${this.GenerateLogDateTime()}] - ${message}`, ...params);
    }

    info = (message: any, ...params: any[]) => {
        if (message != null)
            console.info(`[${this.GenerateLogDateTime()}] - ${message}`, ...params);
    }

    debug = (message: any, ...params: any[]) => {
        if (message != null)
            console.debug(`[${this.GenerateLogDateTime()}] - ${message}`, ...params);
    }

    warn = (message: any, ...params: any[]) => {
        if (message != null)
            console.warn(`[${this.GenerateLogDateTime()}] - ${message}`, ...params);
    }

    error = (message: any, error?: (Error | undefined | any), ...params: any[]) => {
        if (message != null) {
            let dateTime = this.GenerateLogDateTime();
            if (error == null)
                console.error(`[${dateTime}] - ${message}`, ...params);
            else {
                if (typeof error === 'string')
                    console.error(`[${dateTime}] - ${message} - ${error}`, ...params);
                else console.error(`[${dateTime}] - ${message}\nName: ${error.name}\nMessage: ${error.message}`, ...params);
            }
        }
    }

    GenerateLogDateTime = (): string => {
        const date: Date = new Date();
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
    }
}

const log: Logger = new Logger();
export { log };